import {loginButton, loadingButton} from "./dom";

export function setToLoading(): void {
    loginButton.classList.add("hidden");
    loadingButton.classList.remove("hidden");
}

export function disableLoading(): void {
    loadingButton.classList.add("hidden");
    loginButton.classList.remove("hidden");
}